import { win } from '@rei/browser-shim';
import pushpopParam from '@rei/pushpop-param';
import ajaxCacher from '../../legacy/components/ajax-cacher'; // eslint-disable-line

function LocationSearch() {
  this.model = {
    context: null,
    searchString: null,
  };

  this.init = () => {
    // App Base Path read from window
    const { context } = win;

    if (context) {
      this.model.context = context;
      pushpopParam.setRootPath(context);
    }

    const { location = {} } = win;
    const { pathname } = location;

    // create course id "slug" which preserves the id when removing location
    const [, , id] = pathname.split('/');
    const trackedSlugs = [{ name: id, order: 1, type: 'default' }];
    pushpopParam.trackSlugs(trackedSlugs);
  };

  this.pushStateChange = () => {
    this.getSearchResults();
  };

  this.ajaxSuccessCallback = (data) => {
    const { courseUri, queryString } = data;
    const { searchString } = this.model;
    const url = [courseUri, queryString].filter((it) => !!it).join('?');

    // reset page to basic course page if removing location
    if (searchString === null) {
      window.location.replace(courseUri);
    } else {
      // set page to next url if adding/changing location
      window.location.replace(url);
    }
  };

  this.ajaxErrorCallback = (data) => {
    // it is not clear what is supposed to happen if this call fails
    // eslint-disable-next-line
    console.log('ajaxErrorCallback', data);
  };

  // Rest Service
  this.getSearchResults = ({ searchString } = {}) => {
    this.model.searchString = searchString;

    // Construct Ajax URL
    let restPath = '';
    const currPathName = pushpopParam.getPathName();
    const queryString = win.location.search.substring(1);

    if (this.model.context) {
      // Construct Rest Pathname
      restPath = currPathName.replace(this.model.context, `${this.model.context}/model`);
    }

    if (queryString && queryString !== '') {
      restPath += `?${queryString}`;
    }

    // Cleanup Url
    restPath = restPath.replace(/\/\//g, '/');

    ajaxCacher.ajax(restPath, this.ajaxSuccessCallback, this.ajaxErrorCallback);
  };
}

// Create Global Event Search App
// this is required because LocationSearchFacet is shared with the search page
const appObservable = new LocationSearch();
appObservable.init();
win.appObservable = appObservable;
